
<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card ">
    <div class="card-header">
      <div class="float-end fit-content h-100 d-flex flex-column align-items-end mt-2 gap-2">
      </div>
      <h5 class="card-title">Estaciones</h5>
      <h6 class="card-subtitle text-muted">Activa o desactiva el cambio de verano/invierno</h6>

    </div>
    <div class="card-body p-4">

      <div class="d-flex align-items-center gap-2 mb-3">
        <div class="fw-semibold mb-0">
          Cambio estación
          <!-- <span *ngIf="summer.enabled"> Activado </span>
          <span *ngIf="!summer.enabled"> Desactivado </span> -->
        </div>
        <label class="switch mb-0">
          <input type="checkbox" [(ngModel)]="dataSeason.enable" *ngIf="dataSeason" (change)="changesMade=true">
          <span class="slider round"></span>
        </label>
      </div>


      <div class="d-flex flex-column gap-3" *ngIf="dataSeason?.enable" >
        <div class="border rounded-2 p-3">
          <div class="fw-semibold mb-2">Verano</div>
          <div class="d-flex flex-nowrap align-items-center justify-content-around gap-2">
            <div class="input-group input-group-sm" style="width: 240px">
              <span class="input-group-text">{{'day' | translate}}</span>
              <input type="date" class="form-control" [(ngModel)]="summer.startDate" disabled>
            </div>
            <div class="input-group input-group-sm" style="width: 180px">
              <span class="input-group-text">{{'time' | translate}}</span>
              <input type="time" class="form-control" [(ngModel)]="summer.startTime" disabled>
            </div>
          </div>
        </div>

        <div class="border rounded-2 p-3">
          <div class="fw-semibold mb-2">Invierno</div>
          <div class="d-flex flex-nowrap align-items-center justify-content-around gap-2">
            <div class="input-group input-group-sm" style="width: 240px">
              <span class="input-group-text">{{'day' | translate}}</span>
              <input type="date" class="form-control" [(ngModel)]="winter.startDate" disabled>
            </div>
            <div class="input-group input-group-sm" style="width: 180px">
              <span class="input-group-text">{{'time' | translate}}</span>
              <input type="time" class="form-control" [(ngModel)]="winter.startTime" disabled>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column gap-3" *ngIf="!dataSeason?.enable" >
        <span class="text-muted" > Sin cambio de hora planificado </span>
      </div>


              <div class="form-group row mt-4">
          <div class="col-12 d-flex justify-content-center gap-2">
            <button type="submit" class="btn btn-primary" (click)="save()" [disabled]="!changesMade">{{"overwrite" | translate}}</button>
            <button type="submit" class="btn btn-light" [disabled]="!changesMade"  (click)="restore()">{{"restore" | translate}}</button>
          </div>
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
          <div class="alert-message">
            {{ error }}
          </div>
        </div>
        <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
          <div class="alert-message">
            {{"updatedSuccesfully" | translate}}
          </div>
        </div>
    </div>
  </div>
</div>
